import Link from 'next/link';
import { twMerge } from 'tailwind-merge';
import { UrlObject } from 'url';
import { ReactNode, useCallback } from 'react';

interface Props {
    className?: string;
    color?: 'primary';
    size?: 'normal' | 'small';
    href?: string | UrlObject;
    onClick?: () => void;
    preventDefault?: boolean;
    leftAddon?: ReactNode;
    rightAddon?: ReactNode;
    children: ReactNode;
    target?: string;
}

export function TextButton({
    className,
    color = 'primary',
    size = 'normal',
    onClick,
    href,
    leftAddon,
    rightAddon,
    children,
    preventDefault = false,
    target,
}: Props) {
    const classNames = twMerge(
        'inline-flex text-left font-medium',
        size === 'small' && 'text-sm',
        color === 'primary' && 'text-primary-500',
        className,
    );

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();

            if (onClick) {
                onClick();
            }
        },
        [onClick],
    );

    if (href != null) {
        return (
            <Link target={target} href={href} className={classNames}>
                {renderChildren()}
            </Link>
        );
    }

    return (
        <button
            type={onClick == null ? 'submit' : 'button'}
            className={classNames}
            onClick={preventDefault ? handleClick : onClick}>
            {renderChildren()}
        </button>
    );

    function renderChildren() {
        return (
            <span className="inline-flex items-center gap-2">
                {leftAddon != null && leftAddon}
                <span>{children}</span>
                {rightAddon != null && rightAddon}
            </span>
        );
    }
}
